// API de usuarios. Ver CLAUDE.md §5.
import { api } from './api'
import type { DataResponse, PaginatedResponse, Role, User } from '@/types'

export interface UserCreateInput {
  email: string
  name: string
  role: Role
  phone?: string | null
  manager_id?: string | null
  warehouse?: string | null
}

export interface UserUpdateInput {
  name?: string
  role?: Role
  phone?: string | null
  manager_id?: string | null
  warehouse?: string | null
  is_active?: boolean
}

export async function listUsers(page = 1, size = 100) {
  const { data } = await api.get<PaginatedResponse<User>>('/users', { params: { page, size } })
  return data
}

export async function createUser(payload: UserCreateInput) {
  const { data } = await api.post<DataResponse<User>>('/users', payload)
  return data.data
}

export async function updateUser(id: string, payload: UserUpdateInput) {
  const { data } = await api.patch<DataResponse<User>>(`/users/${id}`, payload)
  return data.data
}

/** Solo director; el backend rechaza usuarios con actividad registrada (409). */
export async function deleteUser(id: string) {
  await api.delete(`/users/${id}`)
}
